import { createApp } from "vue";
import axios from "axios";
import { createHead } from "@unhead/vue";

import App from "./App.vue";
import router from "./router/index";
import { store } from "./store/store";

import BootstrapCompat from "./plugins/bootstrap-compat";
import MetaInfoPlugin from "./plugins/metaInfoMixin";
import SweetAlertPlugin from "./plugins/sweetalert";
import VuelidateCompat from "./plugins/vuelidateCompat";
import LazyTube from "./components/compat/LazyTube";

import VueLazyload from "vue3-lazyload";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import carousel from "vue-owl-carousel";
import GoTop from "@inotom/vue-go-top";
import VueTypedJs from "vue-typed-js";
import VuePlyr from "vue-plyr";

import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/custom.css";
import "./assets/css/fonts/icomoon/style.css";
import "./assets/css/main.css";

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(router);
app.use(store);
app.use(BootstrapCompat);
app.use(MetaInfoPlugin);
app.use(SweetAlertPlugin);
app.use(VuelidateCompat);
app.use(VueLazyload, {
  loading: "",
  error: "",
});
app.use(LazyTube);

app.component("carousel", carousel);
app.component("go-top", GoTop);
app.component("vue-typed-js", VueTypedJs);
app.component("vue-plyr", VuePlyr);
app.component("v-select", vSelect);

const prod = import.meta.env.PROD;
const shouldSW = "serviceWorker" in navigator && prod;
if (shouldSW) {
  navigator.serviceWorker.register("/service-worker.js").then(() => {
    console.log("Service Worker Registered!");
  });
}

router.beforeResolve((to, from, next) => {
  if (
    store.state.favourite.some((item) => {
      return item.name === to.name;
    }) == false
  ) {
    if (store.state.favourite.length == 5) {
      store.state.favourite.splice(0, 1);
    }
    store.state.favourite.push({
      name: to.name,
      title: to.meta.title,
      description: to.meta.description,
    });
  }
  next();
});

axios.defaults.headers.common = { Accept: "application/json" };
// axios.defaults.baseURL = 'http://172.16.10.107:8000/api/v1/';
axios.defaults.baseURL = "https://web.idlc.com/api/v1/";
// axios.defaults.baseURL = "https://idlc-fl.singularitybd.net/api/v1/";

app.mount("#app");
